import { cn } from "@/utils";

interface StepperProps {
  step: number;
}

const STEPS = ["Usuário", "Pagamento"];

export default function Stepper({ step }: StepperProps) {
  return (
    <ol className="mx-auto mb-10 flex w-full max-w-md items-center gap-3">
      {STEPS.map((label, index) => {
        const current = index + 1;
        const done = step > current;
        const active = step === current;

        return (
          <li key={label} className="flex flex-1 items-center gap-3">
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  "flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold transition-colors duration-500 ease-soft",
                  done || active
                    ? "bg-[var(--tenant-accent-color)] text-white"
                    : "bg-checkout-fill-strong text-checkout-muted"
                )}
              >
                {current}
              </span>
              <span
                className={cn(
                  "text-sm",
                  active || done ? "text-checkout-fg" : "text-checkout-muted"
                )}
              >
                {label}
              </span>
            </div>
            {index < STEPS.length - 1 && (
              <span
                className={cn(
                  "h-px flex-1 transition-colors duration-500 ease-soft",
                  done ? "bg-[var(--tenant-accent-color)]" : "bg-checkout-fill-strong"
                )}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
